import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Janus admin module — `/janus` on console.francisquini.ai.
 *
 * Surface is `'admin'` — registered only on the console host.
 * Dashboard answers "Qual host atende qual domínio, e qual config está
 * live?" Per `arkheus/docs/cockpit/dashboards/tier-4-admin-baixa-frequencia.md §4.2`.
 */
export const manifest: ModuleManifest = {
  module_id: 'janus',
  display_name: 'Janus',
  surface: 'admin',
  routes: [
    {
      path: '/janus',
      component: () =>
        import('@/routes/_app/janus').then((m) => ({
          default: m.JanusHomePage,
        })),
      title: 'Janus — Hosts e runtime config',
      permissions: [],
    },
    {
      path: '/janus/hosts',
      component: () =>
        import('@/routes/_app/janus').then((m) => ({
          default: m.JanusHostsPage,
        })),
      title: 'Janus — Hosts',
      permissions: [],
    },
    {
      path: '/janus/hosts/$host',
      component: () =>
        import('@/routes/_app/janus').then((m) => ({
          default: m.JanusHostDetailPage,
        })),
      title: 'Janus — Host detail',
      permissions: [],
    },
    {
      path: '/janus/runtime-config',
      component: () =>
        import('@/routes/_app/janus').then((m) => ({
          default: m.JanusRuntimeConfigPage,
        })),
      title: 'Janus — Runtime config',
      permissions: [],
    },
    {
      path: '/janus/allowlists',
      component: () =>
        import('@/routes/_app/janus').then((m) => ({
          default: m.JanusAllowlistsPage,
        })),
      title: 'Janus — Allowlists',
      permissions: [],
    },
    {
      path: '/janus/drift',
      component: () =>
        import('@/routes/_app/janus').then((m) => ({
          default: m.JanusDriftPage,
        })),
      title: 'Janus — Drift detection',
      permissions: [],
    },
  ],
}
